<template>
  <div>
    <el-row style="height: 60px; line-height: 60px">
      <el-col :span="12" style="text-align: left; font-size: 20px; color: #0a666b">
        <span class="el-icon-document" style="font-size: 22px"></span>
        审计日志
      </el-col>
    </el-row>

    <el-row style="background-color: white; padding-top: 20px">
      <el-form :inline="true" label-width="auto">
        <el-form-item label="操作类型">
          <el-select v-model="searchForm.actionType" placeholder="操作类型">
            <el-option label="全部" value=""></el-option>
            <el-option label="提交" value="submit"></el-option>
            <el-option label="审核" value="audit"></el-option>
            <el-option label="下架" value="offline"></el-option>
            <el-option label="转换" value="convert"></el-option>
            <el-option label="评论" value="comment"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            style="background-color: #0a666b; color: white; border: none"
            @click="loadAuditLogs()"
          >
            搜索
          </el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row v-if="logList.length == 0">
      <el-col :span="24">
        <el-empty
          description="暂无日志"
          style="height: 900px; background-color: white"
        ></el-empty>
      </el-col>
    </el-row>

    <el-row style="min-height: 900px; background-color: white; padding: 20px">
      <el-table
        :data="logList"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="actionType"
          label="操作类型"
          width="100"
        >
          <template slot-scope="scope">
            <el-tag :type="getActionType(scope.row.operationType)" size="small">
              {{ getActionText(scope.row.operationType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="preprintId"
          label="预印本ID"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="operatorEmail"
          label="操作者"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="operationDetail"
          label="操作详情"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="操作时间"
          width="180"
        ></el-table-column>
      </el-table>

      <br />
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
      >
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
import { getAuditLogList } from '@/api/preprint'

export default {
  name: 'auditLogList',
  data() {
    return {
      userInfo: null,
      searchForm: {
        actionType: ''
      },
      logList: [],
      currentPage: 1,
      pageSize: 10,
      pageTotal: 0
    }
  },
  methods: {
    getActionType(type) {
      const typeMap = {
        submit: 'primary',
        audit: 'success',
        offline: 'warning',
        convert: 'info',
        comment: '',
        resubmit: 'warning'
      }
      return typeMap[type] || 'info'
    },
    getActionText(type) {
      const textMap = {
        submit: '提交',
        audit: '审核',
        offline: '下架',
        convert: '转换',
        comment: '评论',
        resubmit: '重新提交'
      }
      return textMap[type] || type
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadAuditLogs()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadAuditLogs()
    },
    loadAuditLogs() {
      const params = {
        userInfo: this.userInfo,
        operationType: this.searchForm.actionType,
        current: this.currentPage,
        size: this.pageSize
      }
      
      getAuditLogList(params).then(res => {
        if (res.data.errorCode === 0) {
          this.logList = res.data.result.records || []
          this.pageTotal = res.data.result.total || 0
        } else {
          this.$message.error(res.data.errorMessage || '加载失败')
        }
      }).catch(err => {
        console.error('加载审计日志失败:', err)
        this.$message.error('加载失败')
      })
    }
  },
  mounted() {
    // 获取用户信息
    const userInfoStr = this.$cookie.getCookie('userInfo')
    
    if (!userInfoStr) {
      this.$message.error('请先登录')
      this.$router.push({ name: 'login' })
      return
    }
    
    // 如果是字符串，尝试解析
    if (typeof userInfoStr === 'string') {
      try {
        this.userInfo = JSON.parse(userInfoStr)
      } catch (e) {
        this.userInfo = userInfoStr
      }
    } else {
      this.userInfo = userInfoStr
    }
    
    // 检查是否是管理员
    if (this.userInfo.type !== '责任编辑') {
      this.$message.error('您没有权限访问此页面')
      this.$router.push({ name: 'index' })
      return
    }
    
    this.loadAuditLogs()
  }
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/view/preprint/admin/auditLogList.vue